import { createMuiTheme, responsiveFontSizes } from '@material-ui/core/styles';

let theme = createMuiTheme({
  breakpoints: {
    values: {
      xs: 0,
      sm: 600,
      md: 960,
      lg: 1280,
      xl: 1920,
    },
  },
  palette: {
    primary: {
      main: '#1976d2',
      light: '#42a5f5',
      dark: '#1565c0',
    },
    secondary: {
      main: '#f47d06',
      light: '#ff9a40',
      dark: '#c45f00',
    },
    success: {
      main: '#2e7d32',
      light: '#4caf50',
      dark: '#1b5e20',
    },
    error: {
      main: '#d32f2f',
      light: '#ef5350',
      dark: '#c62828',
    },
    warning: {
      main: '#ed6c02',
      light: '#ff9800',
      dark: '#e65100',
    },
    background: {
      default: '#f5f5f5',
      paper: '#ffffff',
    },
  },
  typography: {
    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
    // Responsive font sizes
    h4: {
      fontWeight: 600,
      fontSize: '1.5rem',
      '@media (min-width:600px)': {
        fontSize: '1.75rem',
      },
      '@media (min-width:960px)': {
        fontSize: '2rem',
      },
    },
    h5: {
      fontWeight: 600,
      fontSize: '1.25rem',
      '@media (min-width:600px)': {
        fontSize: '1.4rem',
      },
      '@media (min-width:960px)': {
        fontSize: '1.5rem',
      },
    },
    h6: {
      fontWeight: 600,
      fontSize: '1rem',
      '@media (min-width:600px)': {
        fontSize: '1.15rem',
      },
      '@media (min-width:960px)': {
        fontSize: '1.25rem',
      },
    },
    body1: {
      fontSize: '0.875rem',
      '@media (min-width:600px)': {
        fontSize: '1rem',
      },
    },
    body2: {
      fontSize: '0.75rem',
      '@media (min-width:600px)': {
        fontSize: '0.875rem',
      },
    },
  },
  overrides: {
    MuiCard: {
      root: {
        borderRadius: 8,
        boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
      },
    },
    MuiButton: {
      root: {
        textTransform: 'none',
        borderRadius: 6,
        // Mobile-friendly touch targets
        minHeight: 36,
        '@media (max-width:600px)': {
          minHeight: 44,
          padding: '8px 12px',
        },
      },
    },
    MuiTableHead: {
      root: {
        backgroundColor: '#f5f5f5',
      },
    },
    MuiTableCell: {
      root: {
        // Smaller padding on mobile
        padding: '8px 12px',
        '@media (min-width:600px)': {
          padding: '16px',
        },
      },
      head: {
        fontWeight: 600,
        whiteSpace: 'nowrap',
      },
    },
    MuiDialog: {
      paper: {
        margin: 16,
        // Full width on mobile
        '@media (max-width:600px)': {
          margin: 8,
          width: 'calc(100% - 16px)',
          maxWidth: 'calc(100% - 16px)',
        },
      },
    },
    MuiDialogContent: {
      root: {
        padding: '8px 16px',
        '@media (min-width:600px)': {
          padding: '8px 24px',
        },
      },
    },
    MuiTab: {
      root: {
        minWidth: 'auto',
        padding: '6px 12px',
        '@media (min-width:600px)': {
          minWidth: 160,
          padding: '6px 24px',
        },
      },
    },
    MuiChip: {
      root: {
        height: 24,
        '@media (min-width:600px)': {
          height: 32,
        },
      },
    },
    MuiIconButton: {
      root: {
        // Touch-friendly size on mobile
        padding: 8,
        '@media (max-width:600px)': {
          padding: 12,
        },
      },
    },
  },
});

// Apply responsive font sizes
theme = responsiveFontSizes(theme);

export default theme;
